// extracted by mini-css-extract-plugin
export default {"container":"LatestArticles_container__hf+MH","label":"LatestArticles_label__to9Rq","oddRow":"LatestArticles_oddRow__gqySm","evenRow":"LatestArticles_evenRow__k24cL"};